/**
 * c-video-accordion.js
 * 動画アコーディオンセクションのJavaScript
 */

if (!customElements.get('video-accordion')) {
  class VideoAccordion extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('.c-video-accordion__header');
      this.content = this.querySelector('.c-video-accordion__content');
      this.isOpen = false;
    }

    connectedCallback() {
      if (!this.header || !this.content) return;

      // 初期状態を設定
      const defaultOpen = this.dataset.defaultOpen === 'true';
      this.isOpen = defaultOpen;
      this.updateState();

      // クリックイベント
      this.header.addEventListener('click', this.toggle.bind(this));

      // キーボードイベント
      this.header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle();
        }
      });
    }

    toggle() {
      this.isOpen = !this.isOpen;
      this.updateState();
    }

    updateState() {
      this.header.setAttribute('aria-expanded', this.isOpen.toString());
      this.content.setAttribute('aria-hidden', (!this.isOpen).toString());

      if (this.isOpen) {
        this.content.style.display = 'block';
        // アニメーション用に高さを計算
        const height = this.content.scrollHeight;
        this.content.style.maxHeight = height + 'px';
      } else {
        this.content.style.maxHeight = '0';
        // トランジション完了後に非表示
        setTimeout(() => {
          if (!this.isOpen) {
            this.content.style.display = 'none';
          }
        }, 300);
      }
    }

    disconnectedCallback() {
      if (this.header) {
        this.header.removeEventListener('click', this.toggle);
      }
    }
  }

  customElements.define('video-accordion', VideoAccordion);
}
